import { render } from "./Test2.vue?vue&type=template&id=72898d3d"
import script from "./Test2.vue?vue&type=script&lang=ts"
export * from "./Test2.vue?vue&type=script&lang=ts"
script.render = render

export default script